import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';
import ClientEdit from './ClientEdit';

class ClientEditContainer extends Component {
  componentDidMount() {
    this.props.fetchClientsIfNeeded();
    this.props.setActive(this.props.match.params.id);
  }

  handleSubmit = values => {
    const { submitClientEdit, history } = this.props;
    return submitClientEdit(this.props.match.params.id, values, history);
  };

  render() {
    const { ui } = this.props;
    let props = {
      onSubmit: this.handleSubmit,
      isLoading: ui.get('isLoading'),
      isError: ui.get('isError'),
      errorMessage: ui.get('errorMessage')
    };

    if (this.props.client !== null) {
      props.initialValues = this.props.client;
    }

    return <ClientEdit {...props} />;
  }
}

const mapStateToProps = createStructuredSelector({
  client: selectors.getActive,
  ui: selectors.getUI
});

export default connect(mapStateToProps, actions)(ClientEditContainer);



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientEditContainer.js